import React from 'react';
import Translate from 'react-translate-component';
import { is } from 'ramda';

const Error = (componentProps) => {
    const { error } = componentProps;

    return (
        <div className='input-error'>
            { is(String, error) ? <Translate content={ 'errors.' + error } /> : error }
        </div>
    );
};

export default Error;
